import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import {useTranslation} from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';

import LessonLink from './LessonLink';
import useAnalyticsEventTracker from '../../../../hooks/use-analytics';
import { fetchNpcIcon } from "../../../Helpers/Conversation/ConversationInit";

const Scene = ({ scene, index, openByDefault, objectiveName, level }) => {
  const {t: translate } = useTranslation();
  const [sceneToggled, setSceneToggled] = useState(openByDefault);
  const params = useParams();
  const location = params.location;
  const npcIconUrl = fetchNpcIcon(location);
  const letters = ['A','B','C','D','E'];
  const lessons = scene.lessons
  const [maxHeight, setMaxHeight] = useState(0);
  const gaEventTracker = useAnalyticsEventTracker('Scene Selection');

  let sceneCompleted = () => {
    let accuracyCheck = [];

    // eslint-disable-next-line no-unused-vars
    Object.entries(lessons).map(([key, value]) => {
      if (value.completed === true) {
        if (value.bestAccuracy >= 65) {
          accuracyCheck.push(true);
        } else {
          accuracyCheck.push(false);
        }
      } else {
        accuracyCheck.push(false);
      }
    });

    if (!accuracyCheck.includes(false)) {
      return true;
    }

    return false;
  };

  let toggleIcon = sceneToggled ? faChevronUp : faChevronDown;

  if (sceneCompleted()) {
    toggleIcon = faCheck;
  }

  const updateSceneToggled = () => {
    if (!sceneToggled) {
      gaEventTracker('Scene Dropped Down', `${location} ${objectiveName} ${level} Scene ${letters[index]}`)
    }

    setSceneToggled(!sceneToggled);
  }

  const calcProgress = (scene) => {
    if (!Object.prototype.hasOwnProperty.call(scene, 'lessons'))
      return <p>{translate('no-lessons')}</p>;
    let lessons = scene.lessons;

    return Object.entries(lessons).map(([key, value]) => {
      let lessonClass = 'progress-light';

      if (value.completed === true) {
        if (value.bestAccuracy >= 65) {
          lessonClass = 'progress-light progress-light--complete';
        } else {
          lessonClass = 'progress-light progress-light--attempted';
        }
      }
      return (
        <div className={lessonClass} key={key}>
          {key}
        </div>
      );
    });
  };

  useEffect(() => {
    if (sceneToggled === true) {
      let scene = document.getElementById(`scene_${index}`);
      let lessons = scene.nextSibling.childNodes;
      let newHeight = 0;

      for (let lesson of lessons) {
        newHeight += lesson.clientHeight;
        newHeight += 20; //margin on bottom
      }
      setMaxHeight(newHeight);
    } else {
      setMaxHeight(0);
    }
  }, [sceneToggled]);

  return (
    <Fragment key={index}>
      <div className="scene" id={`scene_${index}`} key={index} onClick={() => {updateSceneToggled();}}>
        <img src={npcIconUrl} className="scene__icon" />
        <div className="scene__info">
          <p className="scene__letter">{translate('scene')} {letters[index]}</p>
          <div className="scene__progress">{calcProgress(scene)}</div>
          <div
            className={`${
              sceneCompleted()
                ? 'scene__toggle scene__toggle--completed'
                : 'scene__toggle'
            }`}
          >
            <FontAwesomeIcon icon={toggleIcon} size="1x" />
          </div>
        </div>
      </div>
      <div
        className={`${
          sceneToggled
            ? 'scene-lessons scene-lessons--toggled'
            : 'scene-lessons'
        }`}
        style={{ maxHeight: `${maxHeight}px` }}
      >
        {Object.entries(lessons).map(([key, value]) => {
          return (
            <LessonLink
              key={key}
              location={location}
              lessonNumber={key}
              sceneId={scene.id}
              lessonData={value}
              objectiveName={objectiveName}
              level={level}
              sceneName={`Scene ${letters[index]}`}
            />
          );
        })}
      </div>
    </Fragment>
  );
};

export default Scene;
